import React, { Component } from "react";
import axios from "axios";

import { ButtonItem, SegmentedItem, TableItemDinamico, dineroDisabledMask, MensajeError } from "../../../Components/Items";
import { Tooltip, message, PageHeader, Tag, Popconfirm } from "antd";
import { connect } from "react-redux";
import { BookFilled, CloseCircleOutlined, EditOutlined, EyeOutlined } from "@ant-design/icons";
import moment from "moment";
import MandarCorreoComplemento from "../CuentasPorCobrar/MandarCorreoComplemento/MandarCorreoComplemento";
import MandarCorreoPago from "../CuentasPorCobrar/MandarCorreoPago/MandarCorreoPago";
import VerPagosRelacionadosAC from "./VerPagosRelacionadosAC/VerPagosRelacionadosAC";
//import MandarCorreoPagos from "./MandarCorreoPagos/MandarCorreoPagos";

class AbonosClientes extends Component {
    tableRef = null;
    state = {
        todasAbonosC: [],
        loading: false,
        totalRecords: 0,
        valor: 0,
        modalVerComplemento: false,
        modalVerComplementoId: null,
        modalVerPago: false,
        modalVerPagoId: null,
        modalVerPagosRelacionados: false,
        modalVerPagosRelacionadosId: false,
    }

    consultarPagos = (params) => {
        this.setState({ loading: true });

        axios
            .post(
                "abonosClientes/selectPagosAbonosClientes",
                { empresaId: this.props.empresaId, ...params },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                if (res.data.success === 2) {
                    this.setState({
                        todasAbonosC:
                            res.data.data.map(value => {
                                return {
                                    ...value,
                                    folio: value.complemento ? ((value.complementoSerie || "") + " - " + (value.complementoNumero || "")) : ((value.pagoSerie || "") + " - " + (value.pagoNumero || "")),
                                    fechaNota: value.fechaNota ? value.fechaNota : value.createdAt,
                                    accion: {
                                        _id: value._id,
                                        estado: value.estado,
                                        complemento: value.complemento,
                                        jsonPago: value.jsonPago,
                                        jsonComplemento: value.jsonComplemento,
                                        estadoAbono: value.estadoAbono,
                                        totalPagadoAbono: value.totalPagadoAbono
                                    },
                                }
                            }),
                        totalRecords: res.data.totalRecords || 0,
                        loading: false
                    });
                } else {
                    this.setState({ todasAbonosC: [], loading: false, totalRecords: 0 });
                }
            })
            .catch((err) => {
                this.setState({ loading: false });
                message.error("Error al consultar los Pagos");
                console.log(err);
            });
    }

    handleCancelarPago = (id) => {
        this.setState({ loading: true });
        axios.post("pagos/cancelarPago", { pagoId: id, empresaId: this.props.empresaId }, { headers: this.props.headersToken }).then(res => {
            if (res.data.success === 2) {
                message.success("Pago cancelado correctamente");
                if (this.tableRef) {
                    this.tableRef.fetchData();
                }
            } else {
                // `pagos/cancelarPago` ya interpreta el acuse del SAT y el rechazo del
                // PAC: manda el motivo en español en `errorTimbrado`. Aquí se estaba
                // descartando todo —hasta el `message`— para mostrar un toast de tres
                // segundos que no decía nada.
                MensajeError({
                    message: res.data.errorTimbrado?.titulo || "No se pudo cancelar el pago",
                    description: res.data.errorTimbrado?.mensaje || res.data.message,
                    detalleTecnico: res.data.errorTimbrado?.detalleTecnico,
                });
            }
            this.setState({ loading: false });
        }).catch(err => {
            message.error("Error al cancelar el Pago");
            console.log(err);
            this.setState({ loading: false });
        });
    }


    enviarPagos(value) {
        this.setState({ modalVerPago: true, modalVerPagoId: value });
    }
    enviarComplemento(value) {
        this.setState({ modalVerComplemento: true, modalVerComplementoId: value });
    }
    cerrarVerComplemento() {
        this.setState({
            modalVerComplemento: false,
            modalVerComplementoId: null,
        });
    }
    cerrarMandarCorreoPago() {
        this.setState({
            modalVerPago: false,
            modalVerPagoId: null,
        });
    }

    agregarAbonoCliente() {
        this.props.history.push("/panel/agregarAbonoCliente");
    }

    editarAbonoCliente(id) {
        this.props.history.push("/panel/editarAbonoCliente", { id });
    }

    cancelarAbonoCliente(value) {
        axios
            .post(
                "abonosClientes/cancelarAbonoCliente",
                { abonoId: value, empresaId: this.props.empresaId },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                if (res.data.success === 2) {
                    message.success("Abono cliente cancelado");
                } else {
                    message.error(res.data.message || "Sucedio un error y no se pudo cancelar");
                }
                if (this.tableRef) {
                    this.tableRef.updateExternalFilters({ valor: this.state.valor });
                }
            });
    }

    verPagosRelacionados(id) {
        this.setState({
            modalVerPagosRelacionados: true,
            modalVerPagosRelacionadosId: id,
        });
    }
    cerrarPagosRelacionados() {
        this.setState({
            modalVerPagosRelacionados: false,
            modalVerPagosRelacionadosId: null,
        });
        if (this.tableRef) {
            this.tableRef.updateExternalFilters({ valor: this.state.valor });
        }
    }

    render() {
        const columns = [
            {
                title: "Folio",
                dataIndex: "folio",
                key: "folio",
                render: (value, record) => (record.pagoSerie || "") + " - " + (record.pagoNumero || ""),
                width: 100,
            },

            {
                title: "Cliente",
                dataIndex: "cliente",
                key: "cliente",
                width: 250,
                buscar: 'cliente',
                ellipsis: true,
            },
            {
                title: "Fecha",
                dataIndex: "fechaPago",
                key: "fechaPago",
                sorter: true,
                render: (value) => moment(value).locale("es").format("DD/MM/YY HH:mm"),
                width: 100,
                ellipsis: true,
                align: "center",
            },
            {
                title: "Forma de Pago",
                dataIndex: "formaDePago",
                key: "formaDePago",
                align: "center",
                width: 80,
                ellipsis: true,
            },
            {
                title: "Moneda",
                dataIndex: "moneda",
                key: "moneda",
                buscar: "moneda",
                responsive: [],
                width: 0,
            },

            {
                title: "Monto",
                dataIndex: "monto",
                key: "monto",
                sorter: true,
                render: (_, record) => (
                    <div style={{ textAlign: "right", display: "flex", alignItems: "center", justifyContent: "flex-end", gap: "4px" }}>
                        <span>{dineroDisabledMask(record.monto)}</span>
                        {record.moneda && <span style={{ fontSize: "12px", color: "#666" }}>{record.moneda}</span>}
                    </div>
                ),
                buscar: "monto",
                width: 100,
                ellipsis: true,
                align: "right",
            },
            {
                title: "Total Aplicado",
                dataIndex: "totalPagadoAbono",
                key: "totalPagadoAbono",
                sorter: true,
                render: (_, record) => (
                    <div style={{ textAlign: "right", display: "flex", alignItems: "center", justifyContent: "flex-end", gap: "4px" }}>
                        <span>{dineroDisabledMask(record.totalPagadoAbono || 0)}</span>
                        {record.moneda && <span style={{ fontSize: "12px", color: "#666" }}>{record.moneda}</span>}
                    </div>
                ),
                buscar: "totalPagadoAbono",
                width: 100,
                ellipsis: true,
                align: "right",
            },
            {
                title: "Saldo Pendiente",
                dataIndex: "saldoPendienteAbono",
                key: "saldoPendienteAbono",
                render: (_, record) => (
                    <div style={{ textAlign: "right", display: "flex", alignItems: "center", justifyContent: "flex-end", gap: "4px" }}>
                        <span>{dineroDisabledMask(record.saldoPendienteAbono || (record.monto - (record.totalPagadoAbono || 0)))}</span>
                        {record.moneda && <span style={{ fontSize: "12px", color: "#666" }}>{record.moneda}</span>}
                    </div>
                ),
                width: 100,
                ellipsis: true,
                align: "right",
            },

            {
                title: "Estado",
                dataIndex: "estado",
                key: "estado",
                render: (value, record) => {
                    if (value === 0) {
                        return <Tag color="red" className="square-tag">Cancelado</Tag>;
                    }
                    if (value === 1) {
                        return <Tag color="green" className="square-tag">Vigente</Tag>;
                    }
                },
                width: 110,
                ellipsis: true,
                align: "center",
            },
            {
                title: "Acción",
                dataIndex: "accion",
                key: "accion",
                align: "center",
                width: window.innerWidth > 1200 ? 100 : 100,
                onHeaderCell: () => ({
                    style: { textAlign: 'center', padding: '4px' }
                }),
                onCell: () => ({
                    className: "acciones-sin-hover",
                    style: { textAlign: 'center', padding: '4px' }
                }),
                render: (value, _, index) => {
                    if (value.estado === 0) return null;

                    let buttons = [];

                    const puedeVerPago = value.jsonPago && !value.complemento;
                    if (puedeVerPago) {
                        buttons.push(
                            <Tooltip key={`ver-pago-${index}`} title="Ver PDF" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                                <ButtonItem
                                    type="default"
                                    size="small"
                                    lila
                                    icon={<BookFilled />}
                                    onClick={() => this.enviarPagos(value._id)}
                                >
                                </ButtonItem>
                            </Tooltip>
                        );
                    }

                    const puedeVerComplemento = value.complemento && value.jsonComplemento;
                    if (puedeVerComplemento) {
                        buttons.push(
                            <Tooltip key={`ver-complemento-${index}`} title="Ver PDF Complemento" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                                <ButtonItem
                                    type="default"
                                    size="small"
                                    naranja
                                    icon={<BookFilled />}
                                    onClick={() => this.enviarComplemento(value._id)}
                                >
                                </ButtonItem>
                            </Tooltip>
                        );
                    }
                    
                    // buttons.push(
                    //     <Popconfirm
                    //         title={"¿Seguro que quieres cancelar este pago?"}

                    //         onConfirm={() => this.handleCancelarPago(value._id)}
                    //         okText="Si, Cancelar"
                    //         cancelText="No"
                    //         okButtonProps={{ danger: true }}

                    //     >
                    //         <CloseCircleOutlined style={{ color: "red" }} />
                    //     </Popconfirm>
                    // );
                    if (value.estadoAbono === 0) {
                        buttons.push(
                            <Tooltip key={`editar-${index}`} title="Editar" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                                <ButtonItem
                                    type="default"
                                    size="small"
                                    cyan
                                    icon={<EditOutlined />}
                                    onClick={() => this.editarAbonoCliente(value._id)}
                                >
                                </ButtonItem>
                            </Tooltip>
                        );
                        buttons.push(
                            <Popconfirm
                                key={`cancelar-${index}`}
                                title="¿Seguro que quieres cancelar este abono cliente?"
                                onConfirm={() => this.cancelarAbonoCliente(value._id)}
                                okText="Sí"
                                cancelText="No"
                                okButtonProps={{ danger: true }}
                            >
                                <Tooltip title="Cancelar" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                                    <ButtonItem
                                        type="default"
                                        size="small"
                                        rojo
                                        icon={<CloseCircleOutlined />}
                                    >
                                    </ButtonItem>
                                </Tooltip>
                            </Popconfirm>
                        );
                    } else {
                        buttons.push(
                            <Tooltip key={`ver-pagos-${index}`} title="Ver Pagos Relacionados" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                                <ButtonItem
                                    type="default"
                                    size="small"
                                    azul
                                    icon={<EyeOutlined />}
                                    onClick={() => this.verPagosRelacionados(value._id)}
                                >
                                </ButtonItem>
                            </Tooltip>
                        );
                    }

                    return <div className="acciones-container">{buttons}</div>;
                },
            },
        ];
        return (
            <>
                <PageHeader
                    title="Abonos Clientes"
                    style={{
                        border: "1px solid rgb(235, 237, 240)",
                        backgroundColor: "white",
                        marginBottom: 10,
                    }}
                    extra={
                        <>
                            {window.innerWidth > 1000 &&
                                <SegmentedItem
                                    options={[{ label: 'Todos', value: 0 }, { label: 'Vigentes', value: 1 }, { label: 'Canceladas', value: 2 }]}
                                    onChange={(value) => {
                                        if (this.tableRef) {
                                            this.tableRef.updateExternalFilters({ valor: value });
                                        }
                                        this.setState({ valor: value });
                                    }}

                                    value={this.state.valor}
                                />
                            }
                            <ButtonItem
                                type="primary"
                                key="agregarAbonoCliente"
                                olivo
                                onClick={this.agregarAbonoCliente.bind(this)}
                                 className="botonAgregar"
                            >
                                Agregar Abono Cliente
                            </ButtonItem>
                        </>
                    }
                />
                <TableItemDinamico
                    ref={(ref) => this.tableRef = ref}
                    onRef={(ref) => this.tableRef = ref}
                    totalRecords={this.state.totalRecords}
                    /*onRow={(record, rowIndex) => {
                        return {
                            onDoubleClick: (event) => {
                                this.props.history.push("/panel/verPagos", { id: record._id });
                            },
                        };
                    }}*/
                    anadirValorFiltro={this.state.valor}
                    onFetchData={this.consultarPagos.bind(this)}
                    loading={this.state.loading}
                    size="small"
                    dataSource={this.state.todasAbonosC}
                    columns={columns}
                    filterStorageKey={"AbonosClientesFiltrosTabla" + this.props.empresaId}
                    pagination={false}
                    setValor={(valor) => this.setState({ valor })}
                    valorDefault={0}
                />
                <MandarCorreoComplemento
                    visible={this.state.modalVerComplemento}
                    id={this.state.modalVerComplementoId}
                    cerrarMandarCorreoComplemento={this.cerrarVerComplemento.bind(this)}
                />
                <MandarCorreoPago
                    visible={this.state.modalVerPago}
                    id={this.state.modalVerPagoId}
                    cerrarMandarCorreoPago={this.cerrarMandarCorreoPago.bind(this)}
                />
                <VerPagosRelacionadosAC
                    visible={this.state.modalVerPagosRelacionados}
                    id={this.state.modalVerPagosRelacionadosId}
                    cerrarPagosRelacionados={this.cerrarPagosRelacionados.bind(this)}
                />
            </>
        );



    }
}

const mapStateToProps = (state) => {
    return {
        headersToken: state.user.headersToken,
        empresaId: state.empresa.id,
        permisoFacturaGlobal:
            state.user.tipo === 0 ||
            state.user.permisos.find(
                (valueTodos) =>
                    valueTodos.permisoId.toString() === "6750916e798d4e0043687240"
            )?.activado,
    };
};

export default connect(mapStateToProps)(AbonosClientes);